import React, { Component } from 'react';
import { SnackbarProvider } from 'notistack';
import { createGenerateClassName, Slide, SlideProps, StylesProvider } from '@material-ui/core';
import { Notifier } from 'components';

import './BasketSnackbarProvider.scss';

const DEFAULT_NOTIFICATION_DURATION = 6000;
const DEFAULT_NOTIFICATION_COUNT = 4;

export class BasketSnackbarProvider extends Component {
    render(): JSX.Element {
        return (
            <StylesProvider
                generateClassName={createGenerateClassName({ seed: 'notistack' })}>
                <SnackbarProvider
                    domRoot={document.body}
                    autoHideDuration={DEFAULT_NOTIFICATION_DURATION}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    maxSnack={DEFAULT_NOTIFICATION_COUNT}
                    TransitionComponent={(props: SlideProps) => <Slide {...props} direction='down' />}>
                    <Notifier />
                    {this.props.children}
                </SnackbarProvider>
            </StylesProvider>
        );
    }
}